












































 import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
 import Util from "../../../lib/util";
 import AbpBase from "../../../lib/abpbase";
 import WareHouse from "../../../store/entities/warehouse";
 @Component
export default class EditWareHouse extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    created(){
        }
    warehouse:WareHouse=new WareHouse();
    save(){
            (this.$refs.warehouseForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    await this.$store.dispatch({
                        type:'warehouse/update',
                        data:this.warehouse
                    });
                    (this.$refs.warehouseForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
    }
    cancel(){
            (this.$refs.warehouseForm as any).resetFields();
            this.$emit('input',false);
        }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }else{
            this.warehouse=Util.extend(true,{},this.$store.state.warehouse.editWareHouse)
        }
    }
    warehouseRule={
        ftId: [{ type:"number",required: true, message: "请选择库区", trigger: "change" }],
            wName:[{required: true,message:'请填写库房名称',trigger: 'blur'}],
            number:[{transform: (value) => String(value),required:true,message:'请填写库房编号',trigger: 'blur'}]
        }
    get factory() {
        return this.$store.state.factory.list;
    }
}
